import { render, staticRenderFns } from "./StatisticsReworksAllIndex.vue?vue&type=template&id=87ae0ed2"
import script from "./StatisticsReworksAllIndex.vue?vue&type=script&lang=js"
export * from "./StatisticsReworksAllIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports